var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.189,
    height: 78.189,
    viewBox: "0 0 78.189 78.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-657.099 -247.243)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_708",
    "data-name": "Ellipse 708",
    cx: 38.594,
    cy: 38.594,
    r: 38.594,
    transform: "translate(657.599 247.743)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11260",
    "data-name": "Path 11260",
    d: "M703.121,277.38v5.45h-27.5V255.31h5.431v22.07Z",
    transform: "translate(16.684 7.006)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9403f0635ec3945222528a3f5fbc9d99.svg";
export { ForwardRef as ReactComponent };